var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEyeVisible = function SvgEyeVisible(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.819176 8.68539C2.26538 5.55572 5.37779 3.375 9 3.375C12.6222 3.375 15.7346 5.55572 17.1808 8.68539C17.2731 8.88499 17.2731 9.11501 17.1808 9.31461C15.7346 12.4443 12.6222 14.625 9 14.625C5.37922 14.625 2.26783 12.446 0.820887 9.31831C0.727657 9.11945 0.725673 8.88774 0.819176 8.68539ZM2.3348 9C3.60894 11.4629 6.12227 13.125 9 13.125C11.8777 13.125 14.3911 11.4629 15.6652 9C14.3911 6.53713 11.8777 4.875 9 4.875C6.12227 4.875 3.60894 6.53713 2.3348 9Z",
    fill: "#0258FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 9C5.625 7.13604 7.13604 5.625 9 5.625C9.016 5.625 9.03198 5.62511 9.04794 5.62534L9.03745 6.37526L9.77248 6.52436C9.75782 6.59664 9.75 6.67202 9.75 6.75C9.75 7.37132 10.2537 7.875 10.875 7.875C11.025 7.875 11.1663 7.84606 11.2951 7.79415C11.5025 7.7106 11.7362 7.72388 11.9328 7.83039C12.1293 7.93689 12.2681 8.12551 12.3113 8.34484C12.3532 8.55737 12.375 8.7765 12.375 9C12.375 10.864 10.864 12.375 9 12.375C7.13604 12.375 5.625 10.864 5.625 9ZM8.29955 7.26021C7.61099 7.53769 7.125 8.21209 7.125 9C7.125 10.0355 7.96447 10.875 9 10.875C9.9072 10.875 10.6639 10.2307 10.8375 9.37474C9.57906 9.35714 8.53469 8.45393 8.29955 7.26021Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyeVisible, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye-visible.23bfc540.svg";
export { ForwardRef as ReactComponent };